import api from '../api/api';
import { logger } from '../utils/logger';

export class ReporteService {

  
  static async getUrlReporteGestion(idUsuario: number): Promise<any> {
    try {
      // Enviarlo como query param o como parte de la URL según requiera tu backend
      // Opción A: Query Param
      const response = await api.get(`/reportes/awsqs/reporte-gestion?idUsuario=${idUsuario}`);
      
      return response.data;
    } catch (error: any) {
      logger.error('Error al obtener URL de QuickSight:', logger.safeError(error));
      throw error;
    }
  }
}